import { render, staticRenderFns } from "./VersionHistoryEdit.vue?vue&type=template&id=5e78712f"
import script from "./VersionHistoryEdit.vue?vue&type=script&lang=js"
export * from "./VersionHistoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports